import { Button, Divider, Input, Upload, message, DatePicker, List, Switch } from "antd";
import Form from "antd/es/form";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { PresentationService } from "../../Services/PresentationService";
import { readFileDataAsBase64 } from "../../global/FileConverter";
import Swal from "sweetalert2";
import { AuthenticationService } from "../../Services/AuthService";
import { useNavigate, useLocation } from "react-router-dom";
import { AiOutlineFilePdf } from "react-icons/ai";
import { TbTrashX } from "react-icons/tb";
import { FilePdfOutlined } from '@ant-design/icons';
import { TbArrowBackUp } from "react-icons/tb";
import { Link } from "react-router-dom";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
const dateFormat = 'DD/MM/YYYY';
// const dateFormat = 'D MMMM YYYY';
const PresentationEntry = () => {
  const [form] = Form.useForm();
  const location = useLocation();
  const navigate = useNavigate();
  const [loadingFormSubmit, setLoadingFormSubmit] = useState(false);
  const [formDisabled, setFormDisabled] = useState(false);
  const values = Form.useWatch([], form);
  const [docFileList, setDocFileList] = useState([]);
  const [docFileValue, setDocFileValue] = useState(null);
  const presentationService = new PresentationService();
  const [presentationId, setPresentationId] = useState();
  const [title, setTitle] = useState("Add");
  useEffect(() => {
    const authService = new AuthenticationService();
    if (authService.getUserData?.role !== "3") {
      navigate('/user/unauthorized'); // Redirect to error page if role is not admin
    }
  }, [navigate]);
  useEffect(() => {
    if (location?.state?.EditFlag === true) {
      form.setFieldsValue({
        presentationDate: dayjs(location?.state?.data?.presentationDateWC),
        titleEnglish: location?.state?.data?.titleEnglish,
        titleHindi: location?.state?.data?.titleHindi,
        isActive: (location?.state?.data?.isActive === 1) ? true : false
      })
      setPresentationId(location?.state?.data?.presentationId)
      setTitle("edit")
    }
  }, [location?.state, form])
  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setFormDisabled(true);
      },
      () => {
        setFormDisabled(false);
      }
    );
  }, [values, form]);
  useEffect(() => {
    const genRandomKey = async () => {
      if (docFileList && docFileList.length > 0) {
        try {
          let data = await readFileDataAsBase64(docFileList[0]);
          setDocFileValue(() => ({
            documentExtension: ".pdf",
            documentMimeType: "application/pdf",
            documentTag: "PresentationDocs",
            documentType: 10,
            documentImageGroup: 2,
            stateId: 22,
            documentList: [
              {
                documentInByte: data,
                documentLabel: "PresentationDocs",
              },
            ],
          }));
        } catch (error) {
          console.error("Error reading file:", error);
        }
      }
    };
    genRandomKey();
  }, [docFileList]);
  const onRemoveDoc = (file) => {
    const index = docFileList.indexOf(file);
    const newFileList = docFileList.slice();
    newFileList.splice(index, 1);
    setDocFileList(newFileList);
  }
  const beforeUploadDoc = (file, docFileList) => {
    if (file.size / 1024 / 1024 > 10) {
      message.open({
        type: 'error',
        content: <> <strong>{file.name}</strong> is greater than 10MB.</>,
        duration: 4
      });
      return false;
    }
    if (file.type !== 'application/pdf') {
      message.open({
        type: 'error',
        content: <>Only .pdf files are allowed</>,
        duration: 4
      });
      return false;
    }
    if (docFileList.findIndex((itm) => { return (itm.name === file.name && itm.size === file.size && itm.type === file.type) }) !== 0) {
      message.open({
        type: 'error',
        content: <><strong>{file.name} already added.</strong></>,
        duration: 4
      });
      return false;
    }
    setDocFileList([file]);
    return false;
  }
  const SubmitDetails = async () => {
    try {
      setLoadingFormSubmit(true);
      const payload = {
        presentationId: presentationId,
        presentationDate: form.getFieldValue("presentationDate"),
        titleEnglish: form.getFieldValue("titleEnglish"),
        titleHindi: form.getFieldValue("titleHindi"),
        blDocuments: docFileValue ? [docFileValue] : [],
        isActive: form.getFieldValue("isActive") === true ? 1 : 0,
        VerificationRemark: form.getFieldValue("verificationRemark")
      };
      let res;
      if (location?.state?.EditFlag === true) {
        res = await presentationService.PresentationUpdate(payload);
      }
      else {
        res = await presentationService.PresentationInsert(payload);
      }
      if (res.data.status) {
        Swal.fire({
          html: res.data.message,
          icon: "success",
          showConfirmButton: false,
          timer: 2000
        });
        navigate("/user/presentation/presentation-list");
      }
      else {
        Swal.fire({
          html: res.data.message,
          icon: "error"
        });
      }
    } catch (error) {
      console.error("Error at submitting Presentation details:", error);
    } finally {
      setLoadingFormSubmit(false);
    }
  };
  return (
    <Container className="project-entry-form mt-4">
      <Row className="justify-content-center">
        <Col lg={11}>
          <Card className="mb-4 shadow-sm">
            <Card.Header className="d-flex align-items-center justify-content-between">
              <h3>{title === "edit" ? "Edit Presentation Details" : "Add Presentation"}</h3>
              <Link className="btn btn-secondary" to="/user/presentation/presentation-list">
                <TbArrowBackUp /> Back
              </Link>
            </Card.Header>
            <Card.Body>
              <Form
                layout="vertical"
                form={form}
                name="PresentationForm"
                onFinish={SubmitDetails}
                scrollToFirstError
                initialValues={{ presentationDate: dayjs(), isActive: true }}
              >
                <Card className="mb-3">
                  <Card.Header className="fw-bold">Subject/Title</Card.Header>
                  <Card.Body>
                    <Row gutter={16}>
                      <Col md={6}>
                        <Form.Item name="titleEnglish" label="Subject/Title (English)" rules={[
                          { required: true, message: '*Required!' },
                          {
                            type: "string",
                            max: 500,
                            message: "Max length exceeded",
                          },
                        ]}>
                          <Input.TextArea showCount maxLength={500} placeholder="Enter Subject/Title (English)" autoSize={{ minRows: 3, maxRows: 5 }} />
                        </Form.Item>
                      </Col>
                      <Col md={6}>
                        <Form.Item name="titleHindi" label="Subject/Title (Hindi)" rules={[
                          { required: true, message: '*Required!' },
                          {
                            type: "string",
                            max: 500,
                            message: "Max length exceeded",
                          },
                        ]}>
                          <Input.TextArea showCount maxLength={500} placeholder="Enter Subject/Title (Hindi)" autoSize={{ minRows: 3, maxRows: 5 }} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                <Card className="mb-3">
                  <Card.Header className="fw-bold">Upload Doc / Presentation Date</Card.Header>
                  <Card.Body>
                    <Row gutter={16}>
                      <Col md={6}>
                        <Form.Item
                          name="projectDocEnglish"
                          label="Upload Doc"
                          rules={[
                            { required: !location?.state?.EditFlag, message: "*Required!" }
                          ]}

                        >
                          <div>
                            <Upload.Dragger name="files"
                              beforeUpload={beforeUploadDoc}
                              fileList={docFileList}
                              accept="application/pdf"
                              disabled={docFileList.length >= 1}
                              showUploadList={false}
                            >
                              <p className="ant-upload-drag-icon">
                                <FilePdfOutlined />
                              </p>
                              <p className="ant-upload-text">Click or drag file to this area to upload</p>
                              <p className="ant-upload-hint">Only PDF file with size less than 10MB is allowed</p>
                            </Upload.Dragger>

                            {(docFileList.length > 0) && <List className="mt-1"
                              itemLayout="horizontal"
                              dataSource={docFileList}
                              bordered
                              renderItem={(item, index) => (
                                <List.Item key={index}
                                  actions={[<Button key="list-loadmore-edit" className="btn btn-outline-danger" onClick={() => { onRemoveDoc(item) }}><TbTrashX /></Button>]}>
                                  <List.Item.Meta
                                    avatar={<AiOutlineFilePdf />}
                                    title={item.name}
                                    description={`File Type: ${item.type} | Size: ${(item.size / 1024).toFixed(2)}KB`}

                                  />
                                </List.Item>
                              )}

                            />}
                          </div>
                        </Form.Item>
                      </Col>
                      <Col md={6}>
                        <Form.Item name="presentationDate" label="Presentation Date" rules={[
                          { required: true, message: '*Required!' },
                        ]}>
                          <DatePicker format={dateFormat} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                <Card className="mb-3">
                  <Card.Header className="fw-bold">Additional Details</Card.Header>
                  <Card.Body>
                    <Row gutter={16}>
                      <Col md={6}>
                        <Form.Item name="verificationRemark" label="Remark" rules={[
                          { required: location?.state?.EditFlag, message: 'Required!' },
                          {
                            type: "string",
                            max: 250,
                            message: "Max length exceeded",
                          },
                        ]}>
                          <Input.TextArea showCount maxLength={250} placeholder="Enter Remark" autoSize={{ minRows: 3, maxRows: 5 }} />
                        </Form.Item>
                      </Col>
                      <Col md={6}>
                        <Form.Item name="isActive" label="Is Active:" valuePropName="checked"
                          rules={[
                            { required: true, message: 'Required!' }
                          ]}>
                          <Switch />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                <div className="text-center mt-2">
                  <Divider />
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={!formDisabled}
                    loading={loadingFormSubmit}
                  >
                    Submit ({title === "edit" ? "Update" : "Save"})
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PresentationEntry;
